<template>

<div >
 
            <Room  :roomRequest="rooms"  @selected="onSelectedRooms($event)"/>




</div>
</template>

<script>
import Room from "./RoomCard";
require("linqjs");
export default {
  components: {
  Room
  },
  data: () => ({
    step:0,
    params: {},
    availRooms: [],
    searchItems:{},
    roomsRequest: [],
      showAmenities: {},
  }),
 props: {
    rooms: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  mounted() {},
   computed: {
   
   },
  methods: {
     
   onSelectedRooms(items) {
    this.$emit('selected' , items);
    
   },
   onShowAmenities(id) {
      this.$set(this.showAmenities, id, true);
    },
    onHideAmenities(id) {
      this.$set(this.showAmenities, id, false);
    },
  },
  created() {
      
  }
};
</script>

<style lang="scss" scoped>
.change-room {
      position: absolute;
    left: 0;
    margin-left: 40px;
    margin-top: 3px !important;
    color: #0a6c9f;
    cursor: pointer;
    font-size: 13px;
}
.feature-list {
  position: absolute;
  left: 15px;
}
.room-desc {
  display: flex;
}
.room-desc #capacity {
 margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}
.room-desc #exterabed {
 margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}
.room-divider {
  text-align: center;
  height: 1px;
  margin: 10px 0 10px 0;
  background-color: #e1e8ed;
}
.room {
  display: grid;
  padding: 10px 10px 0px 10px;
}
.room #title {
  font-weight: bold;
  color: #08446a;
}
.room .option {
  margin-bottom: 8px !important;
  color: black;
}
.room-features #title {
  color: #777777;
  line-height: 10px !important;
}
.choice {
  display: grid;
}
.option-title i {
  font-size: 17px;
}
.option-title span {
  font-weight: bold;
}

.more-amenities {
  color: #0a6c9f;
  cursor: pointer;
}

#room-feature {
  display: flex;
      margin-top: 10px;
}
.icon-feature {
  font-size: 18px;
  color: #08446a;
  cursor: pointer;
  transition: 0.4s;
}
.icon-feature:hover {
  font-size: 20px;
  color: #0879f3;
  cursor: pointer;
}

.fade-enter-active{
  transition: opacity 1.3s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>